<template>
  <div>
    <div class="wrapper">
      <comheader :index="3"></comheader>
      <main id="content" role="main">
        <input type="hidden" name="hdnAgeText" id="hdnAgeText" value="Age" />
        <input
          type="hidden"
          name="hdnDateTimeText"
          id="hdnDateTimeText"
          value="Date Time (UTC)"
        />
        <input
          type="hidden"
          name="hdnAgeTitle"
          id="hdnAgeTitle"
          value="Click to show Age Format"
        />
        <input
          type="hidden"
          name="hdnDateTimeTitle"
          id="hdnDateTimeTitle"
          value="Click to show Datetime Format"
        />
        <input
          type="hidden"
          name="hdnTxnText"
          id="hdnTxnText"
          value="Txn Fee"
        />
        <input
          type="hidden"
          name="hdnGasPriceText"
          id="hdnGasPriceText"
          value="Gas Price"
        />
        <input
          type="hidden"
          name="hdnTxnFeeTitle"
          id="hdnTxnFeeTitle"
          value="(Gas Price * Gas Used by Txns) in Ether"
        />
        <input
          type="hidden"
          name="hdnGasPriceTitle"
          id="hdnGasPriceTitle"
          value="Gas Price in Gwei"
        />
        <div class="container space-2">
          <div class="w-md-75 w-lg-50 mx-md-auto">
            <div class="text-center mb-4">
              <h2 class="h3 mb-1">Verify Address Ownership</h2>
              <p>
                Find out more about
                <a href="javascript:;">Verify Address Ownership</a>
              </p>
            </div>
            <div class="card">
              <div class="card-body p-4">
                <div class="alert alert-danger mb-4" role="alert" v-if="sorry">
                  <i class="far fa-exclamation-circle mr-1"></i> Sorry! The
                  Signature Message Verification Failed
                </div>

                <div
                  class="alert alert-success mb-4"
                  role="alert"
                  v-if="succ && !update"
                >
                  <i class="far fa-check-circle mr-1"></i>
                  Congratulations,the address ownership for [{{ address }}] is
                  verified. You may now submit the request to:
                </div>

                <div v-if="succ && !update" style="min-height: 150px">
                  <a href="javascript:;" @click="toUpdateInfo"
                    >1.Update token Information</a
                  >
                </div>

                <form action="" v-if="update">
                  <div id="ContentPlaceHolder1_verifyaddress3div">
                    <div class="js-form-message form-group">
                      <label class="d-block" for="VerifyContractOwnerCreator"
                        >Token Info <span class="text-danger">*</span></label
                      >
                      <textarea
                        name="ctl00$ContentPlaceHolder1$txtVerRawMessage"
                        rows="3"
                        cols="20"
                        id="ContentPlaceHolder1_txtVerRawMessage"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        required=""
                        data-msg="Signed message is required"
                        data-error-class="u-has-error"
                        data-success-class="u-has-success"
                        aria-invalid="false"
                        v-model="tokenInfo"
                      ></textarea>
                      <span
                        id="ContentPlaceHolder1_revVerSignature"
                        class="text-danger small"
                        v-if="update_msg != ''"
                        >{{ update_msg }}</span
                      >

                      <div
                        class="row align-items-center"
                        style="margin-top: 25px"
                      >
                        <div class="col-6"></div>
                        <div class="col-6 text-right">
                          <input
                            type="button"
                            name="ctl00$ContentPlaceHolder1$btnSubmit3"
                            value="Update Token Info"
                            @click="updateInfo"
                            id="ContentPlaceHolder1_btnSubmit3"
                            class="btn btn-sm btn-primary"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <form
                  method="post"
                  action=""
                  @submit="check"
                  id="form1"
                  class="js-validate"
                  novalidate="novalidate"
                  v-if="!succ"
                >
                  <div class="aspNetHidden">
                    <input
                      type="hidden"
                      name="__EVENTTARGET"
                      id="__EVENTTARGET"
                      value=""
                    />
                    <input
                      type="hidden"
                      name="__EVENTARGUMENT"
                      id="__EVENTARGUMENT"
                      value=""
                    />
                    <input
                      type="hidden"
                      name="__VIEWSTATE"
                      id="__VIEWSTATE"
                      value="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"
                    />
                  </div>
                  <div class="aspNetHidden">
                    <input
                      type="hidden"
                      name="__VIEWSTATEGENERATOR"
                      id="__VIEWSTATEGENERATOR"
                      value="B0F30D6A"
                    />
                    <input
                      type="hidden"
                      name="__EVENTVALIDATION"
                      id="__EVENTVALIDATION"
                      value="BddUkvBhLHBSCPWqUJD4IzrQjXAD3CDuF48Do5bw2qY+wpUWfFxYdoHYd5efKBHW435AkOfpo0In++3f5jYHNqaLzRgm6W/vpy4EVBvlCBFBp0vquE1EQB81QX9V4IJLbRcOCqQC2nMb+ub+AN6grH50AwAUsMbmN4jMrwPZbknCdj81JKhEbJ9RwBtIcXZr3FyICaFO8v3Ee7cKbqS9XA=="
                    />
                  </div>
                  <div id="ContentPlaceHolder1_verifyaddress3div">
                    <div class="js-form-message form-group">
                      <label class="d-block" for="VerifyContractOwnerCreator"
                        >Creator Address
                        <span class="text-danger">*</span></label
                      >
                      <input
                        name="ctl00$ContentPlaceHolder1$txtVerContractOwnerCreator"
                        type="text"
                        :value="creator"
                        maxlength="42"
                        id="ContentPlaceHolder1_txtVerContractOwnerCreator"
                        disabled="disabled"
                        class="aspNetDisabled form-control form-control-sm"
                        aria-describedby="contractOwnerCreatorAddressAddon"
                      />
                    </div>
                    <div class="js-form-message form-group u-has-success">
                      <label class="d-block" for="VerifyRawMessage"
                        >Signed Message
                        <span class="text-danger">*</span></label
                      >
                      <textarea
                        name="ctl00$ContentPlaceHolder1$txtVerRawMessage"
                        rows="3"
                        cols="20"
                        id="ContentPlaceHolder1_txtVerRawMessage"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        required=""
                        data-msg="Signed message is required"
                        data-error-class="u-has-error"
                        data-success-class="u-has-success"
                        aria-invalid="false"
                        v-model="message"
                      ></textarea>
                    </div>
                    <div class="js-form-message form-group">
                      <label class="d-block" for="signatureHash"
                        >Message Signature Hash
                        <span class="text-danger">*</span></label
                      >
                      <input
                        name="ctl00$ContentPlaceHolder1$txtVerSignature"
                        type="text"
                        maxlength="133"
                        id="ContentPlaceHolder1_txtVerSignature"
                        class="form-control form-control-sm"
                        required=""
                        autocomplete="off"
                        placeholder="Enter the message signature hash"
                        v-model="signData"
                        data-success-class="u-has-success"
                        autocorrect="off"
                        data-error-class="u-has-error"
                        spellcheck="false"
                        aria-describedby="verSignatureAddon"
                        autocapitalize="off"
                        data-msg="Message signature hash is required"
                      />
                      <span
                        id="ContentPlaceHolder1_revVerSignature"
                        class="text-danger small"
                        style="display: none"
                        >&nbsp; **Invalid Length</span
                      >
                      <div
                        id="ContentPlaceHolder1_txtVerSignature-error"
                        class="invalid-feedback"
                        style="display: block"
                      >
                        Message signature hash is required
                      </div>
                    </div>
                    <div class="row align-items-center">
                      <div class="col-6"></div>
                      <div class="col-6 text-right">
                        <input
                          type="button"
                          name="ctl00$ContentPlaceHolder1$btnReset3"
                          value="Reset"
                          id="ContentPlaceHolder1_btnReset3"
                          class="btn btn-sm btn-secondary mr-1"
                          @click="reset"
                        />
                        <input
                          type="button"
                          name="ctl00$ContentPlaceHolder1$btnSubmit3"
                          value="Verify Ownership"
                          @click="verifyOwner"
                          id="ContentPlaceHolder1_btnSubmit3"
                          class="btn btn-sm btn-primary"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="modal fade"
                    id="myModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                  >
                    <div
                      class="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div class="modal-content">
                        <div class="modal-header p-2">
                          <h5
                            class="
                              pl-3
                              modal-title
                              h6
                              font-weight-bold
                              text-break
                              w-100
                              mt-2
                              mb-2
                            "
                          >
                            Contract Created By Contract
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div class="modal-body ml-1">
                          <p class="mt-1 mb-2">
                            We are not able to automatically verify and assign
                            the ownership of this contract address. Please refer
                            to and follow the instructions in our article
                            <a
                              href="https://info.etherscan.com/contract-created-by-contract/"
                              >here</a
                            >
                            and
                            <a
                              href="/contactus?id=1&amp;parent=verifyAddress&amp;case=1"
                              >contact us</a
                            >
                            afterward with the required signed message.
                          </p>
                        </div>
                        <div class="modal-footer">
                          <button
                            data-dismiss="modal"
                            class="btn btn-sm btn-secondary btn-xs cancel"
                            type="button"
                            causesvalidation="False"
                          >
                            Cancel
                          </button>
                          <a
                            href="/contactus?id=1&amp;parent=verifyAddress&amp;case=1"
                            class="btn btn-sm btn-primary btn-xs"
                            >Proceed To Contact Us</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <comfooter></comfooter>
  </div>
</template>
<script>
import comheader from "@/components/comheader";
import comfooter from "@/components/comfooter";
import { ethers } from "ethers";
import moment from "moment";
import Web3 from "web3";

import { update_code_info } from "@/API/api";
export default {
  data() {
    return {
      creator: "",
      address: "",
      message: "",
      signData: "",
      sorry: false,
      succ: false,
      update: false,
      tokenInfo: "",
      web3: {},
      update_msg: "",
    };
  },
  components: {
    comheader,
    comfooter,
  },
  async mounted() {
    let that = this;

    if (typeof web3 !== "undefined") {
      that.web3 = new Web3(web3.currentProvider);
    } else {
      // set the provider you want from Web3.providers
      that.web3 = new Web3(new Web3.providers.HttpProvider(window.ethereum));
    }

    if (JSON.stringify(that.$route.params) != "{}") {
      that.creator = that.$route.params.creator;
      that.address = that.$route.params.address;
      that.message = that.$route.params.message;
      that.signData = that.$route.params.signData;
      sessionStorage.setItem("creator_addr", that.creator);
      sessionStorage.setItem("contract_addr", that.address);
      sessionStorage.setItem("contract_message", that.message);
      sessionStorage.setItem("contract_sign", that.signData);
    } else {
      that.creator = sessionStorage.getItem("creator_addr");
      that.address = sessionStorage.getItem("contract_addr");
      that.message = sessionStorage.getItem("contract_message");
      that.signData = sessionStorage.getItem("contract_sign");
    }

    if (window.ethereum) {
      try {
        that.provider = new ethers.providers.Web3Provider(window.ethereum);
      } catch (e) {

      }
    }
  },
  methods: {
    async toUpdateInfo() {
      let that = this;
      that.update = true;
    },
    async updateInfo() {
      let that = this;

      let o = {
        signed: that.signData,
        message: that.message,
        userAddress: that.creator,
        codeAddress: that.address,
        info: that.tokenInfo,
      };

      let res = await update_code_info(o);
      that.update_msg = res.message;
    },
    async verifyOwner() {
      let that = this;
  
      if (!that.signData) {
        document.querySelector(
          "#ContentPlaceHolder1_txtVerSignature-error"
        ).style = "display:block";
        document.querySelector("#ContentPlaceHolder1_revVerSignature").style =
          "display:none";
          return;
      }

      if (that.signData.length < 130) {
        document.querySelector("#ContentPlaceHolder1_revVerSignature").style =
          "display:block";

        document.querySelector(
          "#ContentPlaceHolder1_txtVerSignature-error"
        ).style = "display:none";
        return;
      } else {
        document.querySelector("#ContentPlaceHolder1_revVerSignature").style =
          "display:none";
      }

      let v_address = that.web3.eth.accounts.recover(
        that.message,
        that.signData
      );


      if (v_address.toLowerCase() != that.creator.toLowerCase()) {
        that.sorry = true;
      } else {
        that.succ = true;
      }
    },
    reset() {
      let that = this;
      (that.signData = ""), (that.sorry = false);
    },
    check() {
      return false;
    },
  },
  watch: {
    signData() {
      let that = this;

      if (that.signData == "") {
        document.querySelector(
          "#ContentPlaceHolder1_txtVerSignature-error"
        ).style = "display:block";
        document.querySelector("#ContentPlaceHolder1_revVerSignature").style =
          "display:none";
      } else {
        document.querySelector(
          "#ContentPlaceHolder1_txtVerSignature-error"
        ).style = "display:none";
      }
    },
  },
};
</script>
